// eslint-disable-next-line no-shadow
enum EDataSourceActionCrudType {
    Create = 'Create',
    Update = 'Update',
    Delete = 'Delete',
}

export default EDataSourceActionCrudType
